<div class="card" (click)="goto($event)">
    <!-- <div class="clear">
        <mat-icon>clear</mat-icon>
    </div>
    <div class="clear">
        <mat-icon>edit</mat-icon>
    </div> -->
    <div class="thumb site">
        <span class="tumb-number">{{system.number}}</span>
        <ng-container *ngIf="system.siteInfo">
            {{system.siteInfo?.name}}
        </ng-container>
    </div>
    <div class="card-container">
        <div class="actions" *ngIf="system.status">
            <ng-container *ngIf="allStatusOk(); else showError">
                <div class="status-ok" *ngIf="allStatusOk()">
                    <mat-icon>check_circle</mat-icon>
                </div>
            </ng-container>
            <!-- <div class="action">
                <mat-icon>error</mat-icon>
            </div> -->
            <!-- <ng-template #showError>
                <div *ngIf="haveSocket()" class="action icon-container"
                    [ngClass]="{'status-ok': socketOk(), 'status-error': (!socketOk() || !vpnOk()) && !socketUnknown(), 'status-unknown': socketUnknown()}"
                    style="position: relative; display: inline-block;">
                    <mat-icon [matMenuTriggerFor]="unknownSocketMenu"
                        (click)="preventDefault($event)">computer</mat-icon>
                    <span [matMenuTriggerFor]="unknownSocketMenu" *ngIf="socketUnknown()"
                        (click)="preventDefault($event)"
                        style="position: absolute; top: -8px; right: -8px; background: #fff; color: #333; border-radius: 50%; width: 20px; height: 20px; display: flex; align-items: center; justify-content: center; font-weight: bold; font-size: 1rem; box-shadow: 0 1px 4px rgba(0,0,0,0.15);">?</span>
                    <span [matMenuTriggerFor]="unknownSocketMenu" *ngIf="!vpnOk() && !socketUnknown()"
                        (click)="preventDefault($event)"
                        style="position: absolute; top: -8px; right: -8px; background: #fff; color: #890000; border-radius: 50%; width: 20px; height: 20px; display: flex; align-items: center; justify-content: center; font-weight: bold; font-size: 1rem; box-shadow: 0 1px 4px rgba(0,0,0,0.15);">vpn</span>

                </div>
                <mat-menu #unknownSocketMenu="matMenu">
                    <div style="padding: 16px; max-width: 260px; white-space: pre-line;" [innerHTML]="socketTooltip()">
                    </div>
                </mat-menu>

                <ng-container *ngIf="haveSim()">
                    <div *ngIf="showSimError()" class="action status-error"
                        style="position: relative; display: inline-block;">
                        <mat-icon [matMenuTriggerFor]="unknownSimMenu"
                            (click)="preventDefault($event)">sim_card</mat-icon>
                    </div>
                    <mat-menu #unknownSimMenu="matMenu">
                        <div style="padding: 16px; max-width: 260px; white-space: pre-line;" [innerHTML]="simTooltip()">
                        </div>
                    </mat-menu>
                </ng-container>
            </ng-template> -->
            <!-- <div class="status-ok">
                <mat-icon>cloud_circle</mat-icon>
            </div> -->
        </div>
        <span class="title">{{ system.name }}</span>
        <span class="location">{{ system.siteInfo?.location }}</span>

        <button mat-icon-button [matMenuTriggerFor]="moreMenu" (click)="preventDefault($event)"
            style="position: absolute; top: 10px; right: 0;">
            <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #moreMenu="matMenu">
            <mat-list style="padding: 0;">
                <mat-list-item (click)="gotoSite()" style="cursor: pointer; align-items: center; min-height: 40px;">
                    <mat-icon matListIcon style="margin-right: 12px; vertical-align: middle;">business</mat-icon>
                    <span matLine style="vertical-align: middle;">Site</span>
                </mat-list-item>
                <mat-list-item (click)="onConfig()" style="cursor: pointer; align-items: center; min-height: 40px;">
                    <mat-icon matListIcon style="margin-right: 12px; vertical-align: middle;">build</mat-icon>
                    <span matLine style="vertical-align: middle;">Config</span>
                </mat-list-item>

                <mat-list-item (click)="openGuide()" style="cursor: pointer; align-items: center; min-height: 40px;">
                    <mat-icon matListIcon style="margin-right: 12px; vertical-align: middle;">place</mat-icon>
                    <span matLine style="vertical-align: middle;">Location &amp; guide</span>
                </mat-list-item>

                 <!-- <mat-list-item (click)="onSystem()" *ngIf="system.haveShellBuddy && user?.support == true" style="cursor: pointer; align-items: center; min-height: 40px;">
                    <mat-icon matListIcon style="margin-right: 12px; vertical-align: middle;">business</mat-icon>
                    <span matLine style="vertical-align: middle;">System</span>
                </mat-list-item> -->
                <!-- <mat-list-item (click)="openShell($event)" *ngIf="user?.support == true"
                    style="cursor: pointer; align-items: center; min-height: 40px;">
                    <mat-icon matListIcon style="margin-right: 12px; vertical-align: middle;">terminal</mat-icon>
                    <span matLine style="vertical-align: middle;">Logs and actions</span>
                </mat-list-item> -->

                <mat-list-item (click)="openPopupShell($event)" *ngIf="user?.support == true"
                    style="cursor: pointer; align-items: center; min-height: 40px;">
                    <mat-icon matListIcon style="margin-right: 12px; vertical-align: middle;">terminal</mat-icon>
                    <span matLine style="vertical-align: middle;">Service</span>
                </mat-list-item>

            </mat-list>
        </mat-menu>

        <div class="content">
            <ng-content></ng-content>
        </div>

    </div>
</div>